var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnsFull = function SvgEnsFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 54 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ENSFull_svg__a)",
    d: "M33.605 17.287V15.44h-4.543v-2.33h4.113v-1.748h-4.113V9.06h4.543V7.213h-6.592v10.074z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ENSFull_svg__b)",
    d: "M43.945 17.287V7.213h-2.049v6.664l-4.38-6.664h-2.553v10.074h2.048V10.14l4.781 7.147z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ENSFull_svg__c)",
    d: "M52.865 9.614C52.627 8.478 51.647 7 49.094 7c-1.99 0-3.667 1.364-3.667 3.154 0 1.52 1.084 2.558 2.761 2.885l1.47.284c.816.156 1.277.61 1.277 1.193 0 .71-.61 1.236-1.708 1.236-1.484 0-2.212-.895-2.3-1.89l-1.901.484c.163 1.435 1.395 3.154 4.186 3.154 2.45 0 3.801-1.563 3.801-3.112 0-1.42-1.024-2.614-2.94-2.97l-1.47-.27c-.771-.141-1.142-.582-1.142-1.136 0-.668.653-1.279 1.648-1.279 1.336 0 1.81.867 1.915 1.421z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ENSFull_svg__d)",
    d: "M2.809 5.663a2.9 2.9 0 0 1 .943-1.038L10.375 0 3.589 11.222s-.593-1.002-.824-1.51a4.8 4.8 0 0 1 .044-4.05m-2.733 7.74a7.55 7.55 0 0 0 2.964 5.489L10.366 24s-4.583-6.606-8.45-13.178A6.6 6.6 0 0 1 1.14 8.58a3.6 3.6 0 0 1 0-1.076c-.1.187-.297.57-.297.57a8.7 8.7 0 0 0-.791 2.534 15.5 15.5 0 0 0 .024 2.796m18.677.89c-.237-.507-.824-1.509-.824-1.509L11.155 24l6.623-4.622a2.9 2.9 0 0 0 .943-1.038 4.8 4.8 0 0 0 .044-4.05zm2.69-3.694a7.55 7.55 0 0 0-2.966-5.488L11.165 0s4.58 6.606 8.449 13.179c.39.694.652 1.453.774 2.24.054.358.054.72 0 1.077.1-.187.296-.57.296-.57.392-.799.66-1.654.792-2.534.077-.93.07-1.866-.021-2.796z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ENSFull_svg__a",
    x1: 35.311,
    x2: 22.209,
    y1: 26.844,
    y2: -24.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ENSFull_svg__b",
    x1: 35.311,
    x2: 22.209,
    y1: 26.844,
    y2: -24.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ENSFull_svg__c",
    x1: 35.311,
    x2: 22.209,
    y1: 26.844,
    y2: -24.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ENSFull_svg__d",
    x1: 35.311,
    x2: 22.209,
    y1: 26.844,
    y2: -24.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })))));
};
export default SvgEnsFull;